export enum TTXOpenRouterStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export interface TTXOpenRouterProvider {
  sort: string;
  order: string[];
  allow_fallbacks: boolean;
  max_price: { input: number; output: number };
  require_parameters: boolean;
}

export interface TTXCreateOpenRouterBody {
  name: string;
  product: string;
  model: string;
  temperature: number;
  topP: number;
  status: TTXOpenRouterStatus;
  fallbackModels: string[];
  provider: TTXOpenRouterProvider;
}

export interface TTXOpenRouter extends TTXCreateOpenRouterBody {
  _id: string;
  createdBy: string;
  updatedBy: string;
  status: TTXOpenRouterStatus;
}

export type TTXUpdateOpenRouterBody = Partial<TTXCreateOpenRouterBody>;
